import { IOneMessageJson } from "../../../../nodeserver/structs/database.js";
import { Message } from "../models/messages/message.js";
import { OneDialog } from "./one-dialog.js";


export interface OneMessageElement {
    element: JQuery,
    message: IOneMessageJson
}


export function readNumberAttr(el: JQuery<HTMLElement>, attr: string) {
    let atrId = el.attr(attr);
    if (!atrId)
        throw new Error(`Интдетификатор не найден ${attr}`);
    //data-chat-id   
    return +atrId;
}

export const canChangeOrSeeMessage = (actionById?: number) =>
    actionById === user_id || !actionById ||
    userRoles.includes("admin") ||
    userRoles.includes("chatadmin") ||
    userRoles.includes("root");


export const currentMessageQuery = (messageId: number) => `.one-message[data-id="${messageId}"]`;
export const hasSpecialActions = (fromUserId: number) =>
    user_id === fromUserId ||
    userRoles.includes("admin") ||
    userRoles.includes("chatadmin") ||
    userRoles.includes("root");


export const extendClass = "extend";
export const appearClass = "appear";
export const disappearingElement = "disappearing-element";
export const appearingFlexElement = "appearing-flex-element";
export const rotate90deg = "rotate-90deg";
export const rotateMinus45deg = "rotate-edit-img-svg";
export const rotateBack = "rotateBack";





export function resize(el:HTMLElement) {
    setTimeout(function() {
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 1);
  }




export function rebuildMessage(msg: IOneMessageJson) {
    const oldMessageBody = $(currentMessageQuery(msg.id));


    if (oldMessageBody.length !== 0) {
        const classes = oldMessageBody[0].className.split(' ');
        const newMessageBody = Message({
            classes: classes,
            msg: msg
        });
        // const newMessageBody: HTMLElement = (<Message classes={classes} msg={msg} />);
        oldMessageBody.replaceWith(newMessageBody);
    } else {
        let allMessages = $(".one-message");
        let prevElement: JQuery<HTMLElement> | undefined;
        let prevElementId: number | undefined;

        let maxIteratarorValue = allMessages.length - 1;
        let inserted: boolean = false;

        allMessages.each((i, currentMessage) => {

            if (inserted)
                return;

            let currentMessageElement = $(currentMessage);
            let currentId = currentMessageElement.data("id");
            if (prevElementId &&
                (
                    (i === maxIteratarorValue) || (msg.id < currentId && msg.id > prevElementId)
                )
            ) {
                putMessageIn(currentMessageElement, prevElement, msg)
                inserted = true;
                return;
            }

            if (!prevElementId && i === maxIteratarorValue || msg.id < currentId) {
                putMessageIn(currentMessageElement, null, msg)
                inserted = true;
                return;
            }


            prevElement = currentMessageElement;
            prevElementId = currentId;
        })


    }


}

export function putMessageIn(
    currentMessageElement: JQuery<HTMLElement>,
    prevMessageElement: JQuery<HTMLElement> | null | undefined,
    insertMsgJson: IOneMessageJson
) {
    let currentId = currentMessageElement.data("id");
    let prevId = prevMessageElement ? prevMessageElement.data('id') : null;
    if (prevId && prevMessageElement && prevId < insertMsgJson.id && insertMsgJson.id < currentId) {
        let prevOneEl: OneMessageElement = {
            element: prevMessageElement,
            message: createOneMessageJson(prevMessageElement)
        }
        let letNextEl: OneMessageElement = {
            element: currentMessageElement,
            message: createOneMessageJson(currentMessageElement)
        }
        const msgElement = OneDialog.buildMessage(insertMsgJson, prevOneEl, letNextEl);

        prevMessageElement.after(msgElement);
        return;
    }

    if (currentId < insertMsgJson.id) {
        let prevOneEl: OneMessageElement = {
            element: currentMessageElement,
            message: createOneMessageJson(currentMessageElement)
        }
        const msgElement = OneDialog.buildMessage(insertMsgJson, prevOneEl, null);

        currentMessageElement.after(msgElement);

        return;
    }


    if (insertMsgJson.id < currentId) {
        let prevOneEl: OneMessageElement = {
            element: currentMessageElement,
            message: createOneMessageJson(currentMessageElement)
        }
        const msgElement = OneDialog.buildMessage(insertMsgJson, prevOneEl, null);

        currentMessageElement.before(msgElement);
        return;
    }


}

export function createOneMessageJson(el: JQuery<HTMLElement>): IOneMessageJson {
    const ans = el.data('msg');

    return ans;
   

}

